import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalContext } from '@/components/Modals/Modal/config';

import { AppRoute } from '../app/routes';
import { goodsListByWorkshop, materialsList, resourceList } from '../constants';
import { type GoodsType } from '../types/goods';
import { type PlantTypeText } from '../types/plant';
import { type ResourceTypeText } from '../types/resource';

const useGoToProduct = (): ((
  item: ResourceTypeText | PlantTypeText | GoodsType,
) => void) => {
  const navigate = useNavigate();
  const { closeModal } = useContext(ModalContext);
  const goToProduct = (
    item: ResourceTypeText | PlantTypeText | GoodsType,
  ): void => {
    if (resourceList.includes(item as ResourceTypeText)) {
      closeModal();
      navigate(AppRoute.RESOURCES + `/mineResource/${item}`);

      return;
    }

    if (materialsList.includes(item as PlantTypeText)) {
      closeModal();
      navigate(AppRoute.FACTORY + `/${item}`);

      return;
    }

    for (const workshop in goodsListByWorkshop) {
      const list = goodsListByWorkshop[workshop];

      if (list.includes(item)) {
        closeModal();
        const state = { goodsName: item, value: 1000 };
        navigate(AppRoute.WORKSHOP + `/${workshop}`, { state });

        return;
      }
    }
  };

  return goToProduct;
};

export { useGoToProduct };
